import Login from "../views/Login.svelte";
import { mainRoutres } from "./mainRoutres";

export default {
    "/": Login,
    ...mainRoutres,
};
